import { defineMessages } from 'react-intl';

export default defineMessages({
    warningMessage: {
        id: 'ml.quoteandbind.pup.underlyingPolicy.warningMessage',
        defaultMessage: 'The required underlying limit is {liabilityMessage}. Please verify limits.'
    },
    policyType: {
        id: 'ml.quoteandbind.underlyingPolicy.Policy Type',
        defaultMessage: 'Policy Type'
    },
    policyTypeTooltipLabel: {
        id: 'ml.quoteandbind.underlyingPolicy.policyTypeTooltipLabel',
        defaultMessage: 'Which policy type should I select?'
    },
    policyTypeTooltipContent: {
        id: 'ml.quoteandbind.underlyingPolicy.policyTypeTooltipContent',
        defaultMessage: `Personal Auto – policy that covers your personal private passenger vehicles.{br}Homeowners – property insurance policy that covers your house and the assets in your house. This policy type includes home, condo, co-op, renters, landlords and dwelling fire policies.{br}Personal Watercraft Liability – policy that covers your boat or personal watercraft.{br}Recreational Vehicle – is a policy that covers items such as your all-terrain vehicle (ATV), snowmobile, golf cart, moped, etc.{br}Motorcycle – policy that covers your motorcycle.`
    },
    policyInsuredWithUs: {
        id: 'ml.quoteandbind.underlyingPolicy.Policy Insured With Us',
        defaultMessage: 'Is this policy insured with us?'
    },
    carrierName: {
        id: 'ml.quoteandbind.underlyingPolicy.Carrier Name',
        defaultMessage: 'Carrier Name'
    },
    otherCarrierName: {
        id: 'ml.quoteandbind.underlyingPolicy.Other Carrier Name',
        defaultMessage: 'Other Carrier Name'
    },
    policyNumber: {
        id: 'ml.quoteandbind.underlyingPolicy.Policy Number',
        defaultMessage: 'Policy Number'
    },
    insured: {
        id: 'ml.quoteandbind.underlyingPolicy.Insured',
        defaultMessage: 'Insured'
    },
    otherInsured: {
        id: 'ml.quoteandbind.underlyingPolicy.Other Insured',
        defaultMessage: 'Other Insured'
    },
    mmDdYyyy: {
        id: 'ml.quoteandbind.underlyingPolicy.MM/DD/YYYY',
        defaultMessage: 'MM/DD/YYYY'
    },
    effectiveDate: {
        id: 'ml.quoteandbind.underlyingPolicy.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'ml.quoteandbind.underlyingPolicy.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    expirationDateError: {
        id: 'ml.quoteandbind.underlyingPolicy.expirationDateError',
        defaultMessage: 'Expiration date can not be set before effective date.'
    },
    liability: {
        id: 'ml.common.directives.MLUnderlyingPolicyDirectiveCtrl.Liability',
        defaultMessage: 'Liability'
    },
    uninsuredAndUnderInsured: {
        id: 'ml.quoteandbind.underlyingPolicy.Uninsured & Underinsured Motorist',
        defaultMessage: 'Uninsured & Underinsured Motorist'
    },
    underInsured: {
        id: 'ml.quoteandbind.underlyingPolicy.Underinsured Motorists',
        defaultMessage: 'Underinsured Motorists'
    },
    uninsured: {
        id: 'ml.quoteandbind.underlyingPolicy.Uninsured Motorists',
        defaultMessage: 'Uninsured Motorists'
    },
    uninsuredLimit: {
        id: 'ml.quoteandbind.underlyingPolicy.Uninsured Motorists Limit',
        defaultMessage: 'Uninsured Motorists Limit'
    },
    hoCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Homeowners Liability Help Text',
        defaultMessage: "Select the one that most closely corresponds to your current homeowner/dwelling fire liability limit{br}{lessThan} 300,000 Single Limit,{br}{greaterThan} or Equal to 300,000 Single Limit"
    },
    mcCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Motorcycle Liability Help Text',
        defaultMessage: `Select the one that most closely corresponds to your current motorcycle liability limit{br}{lessThan} 100,000/300,000/50,000 or 300,000 Single Limit,{br}Equal to 100/300/50,000 or 100/300/100,{br}Equal to 300,000 or 400,000 Single Limits,{br}{greaterThan} or Equal to 250,000/500,000/100,000 or 500,000 Single Limit`
    },
    wcCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Watercraft Liability Help Text',
        defaultMessage: `Select the one that most closely corresponds to your watercraft liability limit{br}{lessThan} 250,000/500,000 or 300,000 Single Limit,{br}{greaterThan} or Equal to 250,000/500,000 or 300,000 Single Limit,{br}{lessThan} 250,000/500,000 or 300,000 Single Limit,{br}{greaterThan} or Equal to 250,000/500,000 or 300,000 Single Limit`
    },
    rvCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Recreational Liability Help Text',
        defaultMessage: `Select the one that most closely corresponds to your current recreational vehicle liability limit{br}{lessThan} 100,000/300,000/50,000 or 300,000 Single Limit,{br}Equal to 100/300/50,000 or 100/300/100,{br}Equal to 300,000 or 400,000 Single Limits,{br}{greaterThan} or Equal to 250,000/500,000/100,000 or 500,000 Single Limit`
    },
    paCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Automobile Liability Help Text',
        defaultMessage: `Select the one that most closely corresponds to your current auto liability limit{br}{lessThan} 100,000/300,000/50,000 or 300,000 Single Limit,{br}Equal to 100/300/50,000 or 100/300/100,{br}Equal to 300,000 or 400,000,{br}{greaterThan} or Equal to 250,000/500,000/100,000 or 500,000 Single Limit`
    },
    hoCovHelpText_NewProduct: {
        id: 'ml.quoteandbind.underlyingPolicy.Homeowners Liability Help Text - New Product',
        defaultMessage: 'Select the one that corresponds to your current homeowner/dwelling liability limit.  If none of the choices match, please select Other and fill in your limit.'
    },
    mcCovHelpText_NewProduct: {
        id: 'ml.quoteandbind.underlyingPolicy.Motorcycle Liability Help Text - New Product',
        defaultMessage: 'Select the one that corresponds to your current motorcycle liability limit.  If none of the choices match, please select Other and fill in your limit.'
    },
    wcCovHelpText_NewProduct: {
        id: 'ml.quoteandbind.underlyingPolicy.Watercraft Liability Help Text - New Product',
        defaultMessage: 'Select the one that corresponds to your current watercraft liability limit.  If none of the choices match, please select Other and fill in your limit.'
    },
    rvCovHelpText_NewProduct: {
        id: 'ml.quoteandbind.underlyingPolicy.Recreational Liability Help Text - New Product',
        defaultMessage: 'Select the one that corresponds to your current recreational vehicle liability limit.  If none of the choices match, please select Other and fill in your limit.'
    },
    paCovHelpText_NewProduct: {
        id: 'ml.quoteandbind.underlyingPolicy.Automobile Liability Help Text - New Product',
        defaultMessage: 'Select the one that corresponds to your current auto liability limit.  If none of the choices match, please select Other and fill in your limit.'
    },
    uninsuredCovHelpText_NewProduct: {
        id: 'ml.quoteandbind.underlyingPolicy.Uninsured Motorists Help Text - New Product',
        defaultMessage: 'Select the one that corresponds to your current uninsured motorist limit.  If none of the choices match, please select Other and fill in your limit'
    },
    uninsuredAndUnderInsuredCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Uninsured & Underinsured Motorist Help Text',
        defaultMessage: `Select the one that most closely corresponds to your current uninsured motorist limit{br}{lessThan} 100,000/300,000/50,000 or 300,000 Single Limit,{br}Equal to 100/300/50,000 or 100/300/100,{br}Equal to 300,000 or 400,000,{br}{greaterThan} or Equal to 250,000/500,000/100,000 or 500,000 Single Limit,{br}{lessThan} 100,000/300,000/50,000 or 300,000 Single Limit,{br}Equal to 100/300/50,000 or 100/300/100,{br}Equal to 300,000 or 400,000 Single Limits,{br}{greaterThan} or Equal to 250,000/500,000/100,000 or 500,000 Single Limit`
    },
    underInsuredCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Underinsured Motorists Help Text',
        defaultMessage: `Select the one that most closely corresponds to your current underinsured motorist limit{br}{lessThan} 100,000/300,000/50,000 or 300,000 Single Limit,{br}Equal to 100/300/50,000 or 100/300/100,{br}Equal to 300,000 or 400,000,{br}{greaterThan} or Equal to 250,000/500,000/100,000 or 500,000 Single Limit,{br}{lessThan} 100,000/300,000/50,000 or 300,000 Single Limit,{br}Equal to 100/300/50,000 or 100/300/100,{br}Equal to 300,000 or 400,000 Single Limits,{br}{greaterThan} or Equal to 250,000/500,000/100,000 or 500,000 Single Limit`
    },
    uninsuredCovHelpText: {
        id: 'ml.quoteandbind.underlyingPolicy.Uninsured Motorists Help Text',
        defaultMessage: "Select the one that most closely corresponds to your current uninsured motorist limit{br}{lessThan} 100,000/300,000 or 300,000 Single Limit,{br}Equal to 100/300,{br}Equal to 300,000 or 400,000,{br}{greaterThan} or Equal to 250,000/500,000 or 500,000 Single Limit"
    },
    hoWarning: {
        id: 'ml.quoteandbind.underlyingPolicy.HO.Message.Warning.LiabilityLimits',
        defaultMessage: '$300,000 Single Limit'
    },
    mcWarning: {
        id: 'ml.quoteandbind.underlyingPolicy.motorcycle_ml.Message.Warning.LiabilityLimits',
        defaultMessage: '$250,000/$500,000 Bodily Injury and $100,000 Property Damage or $500,000 Single Limit'
    },
    wcWarning: {
        id: 'ml.quoteandbind.underlyingPolicy.PWL.Message.Warning.LiabilityLimits',
        defaultMessage: '$250,000/$500,000 Bodily Injury or $500,000 Single Limit'
    },
    rvWarning: {
        id: 'ml.quoteandbind.underlyingPolicy.recreational_vehicle_ml.Message.Warning.LiabilityLimits',
        defaultMessage: '$250,000/$500,000 Bodily Injury and $100,000 Property Damage or $300,000 Single Limit'
    },
    paWarning: {
        id: 'ml.quoteandbind.underlyingPolicy.PA.Message.Warning.LiabilityLimits',
        defaultMessage: '$250,000/$500,000 Bodily Injury and $100,000 Property Damage or $500,000 Single Limit'
    },
    namedNonOwner_Ext: {
        id: 'ml.common.underlyingPolicy.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    namedNonOwnerHelpText: {
        id: 'ml.common.underlyingPolicy.Named Non-Owner Help Text',
        defaultMessage: 'You have an auto policy that does not list any vehicles. The policy provides liability only coverage when driving a vehicle you don’t own.'
    },
    namedNonOwnerHelpTextTitle: {
        id: 'ml.common.underlyingPolicy.Named Non-Owner Help Text Title',
        defaultMessage: 'What does this mean?'
    }
});
